import { apiFetch } from "core/api/base";

export function * getPlaygroundDashboard ({ namespace, playgroundId }) {
	return yield apiFetch({
		endpoint: `/v1/playground/${namespace}/${playgroundId}/dashboard`,
		method: "GET",
		authenticated: true
	});
}
